import { Box, Paper, Tab, Tabs, Modal } from '@mui/material';
import { useStyles } from '../../styles';
import { useLocation, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import RegisteredEventCardsList from '../../components/RegisteredEventCardsList';
import { useContext, useEffect, useState } from 'react';
import KenLoader from '../../globalComponent/KenLoader';
import Image from '../../utils/assetHelper';
import { getregisteredevents } from '../../utils/services';
import { RegisteredEventCards } from '../../utils/interfaces';
import EventFeedback from '../../components/EventFeedback';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import { enqueueSnackbar } from 'notistack';
import { getRegisterEvents } from '../../../../Utils/apiService';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const createRecord = (items: any) => {
  let data: RegisteredEventCards = {
    category: [items?.category],
    endTime: items?.eventEndTime,
    img: items?.coverImageURL || Image.Images.EventCardCoverImage,
    location: 'Online',
    mode: '',
    startTime: items?.eventStartTime,
    startDate: items?.eventStartDate,
    title: items?.sessionName,
    id: items?.Id,
    questionnaire: items?.questionnaire,
    sessionId: items?.sessionId,
    feedbackSubmitted: items?.feedbackSubmitted,
  };

  return data;
};

const RegisteredEvents: React.FunctionComponent = () => {
  const classes = useStyles();
  const { search } = useLocation();
  const navigate = useHistory();
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as any;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 2,
  };
  const searchParams = new URLSearchParams(search);
  const tab = searchParams.get('tab');
  const [loading, setLoading] = useState<boolean>(false);
  const [eventsData, setEventsData] = useState<any>({
    inreview: [],
    approved: [],
    rejected: [],
  });
  console.log('eventsData', eventsData);
  const [open, setOpen] = useState<boolean>(false);
  const [eventId, setEventId] = useState<string>('');
  const handleOpen = (id: any) => {
    setEventId(id);
    eventsData.completed.map((items: RegisteredEventCards) => {
      if (items.sessionId === id) {
        if (items?.questionnaire && items.questionnaire.length > 0) {
          setOpen(true);
        } else {
          enqueueSnackbar('Feedback not available', { variant: 'warning' });
          setOpen(false);
        }
      }
    });
  };
  const handleClose = () => setOpen(false);

  const TabPanel: React.FunctionComponent<any> = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} style={{marginTop:isMobile?"0px":"50px"}} className={classes.tabPanel}>
      {value === index && <Box component={'div'}>{children}</Box>}
    </div>
  );

  useEffect(() => {
    setLoading(true);
    getRegisterEvents(userData?.applicantId).then((res) => {
      console.log(res,"ressssss12321232");
      
      if (res?.data && typeof res.data === 'string') {
        try {
          const data = JSON.parse(res.data);
          const createdByMeEvents = data?.filter((item: any) => item.createdbyMe === true);
  
      const inReview = createdByMeEvents?.filter((item: any) => !item.isApproved && !item.isRejected);
      const approved = createdByMeEvents?.filter((item: any) => item.isApproved);
      const rejected = createdByMeEvents?.filter((item: any) => item.isRejected);

      console.log(inReview, "inReview, approved, rejected");
      
      const mapCreatedEvent = (item: any): RegisteredEventCards => ({
        category: [item?.category],
        endTime: item?.endTime,
        img: item?.coverImage?.imageUrl || Image.Images.EventCardCoverImage,
        location: 'Online', // update if needed
        mode: '',
        startTime: item?.startTime,
        startDate: item?.startDate,
        title: item?.eventTitle, // ✅ updated here
        id: item?.Id,
        questionnaire: item?.questionnaire,
        sessionId: '', // not needed for created events
        feedbackSubmitted: false,
        suitablefor: item?.suitablefor, // assuming suitableFor is available
      });
  
          setEventsData({
            inreview: inReview.map(mapCreatedEvent),
            approved: approved.map(mapCreatedEvent),
            rejected: rejected.map(mapCreatedEvent),
          });
          setLoading(false);
        } catch (error) {
          console.error('Error parsing created events data:', error);
          setEventsData({
            inreview: [],
            approved: [],
            rejected: [],
          });
          setLoading(false);
        }
      } else {
        setEventsData({
          inreview: [],
          approved: [],
          rejected: [],
        });
        setLoading(false);
      }
    }).catch((err) => {
      setLoading(false);
      console.error(err);
    });
  
    // Leave existing getregisteredevents untouched for now unless that's changing too
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    searchParams.set('tab', newValue);
            navigate.push(`${routes.createdEvents}?tab=${newValue}`);
  };

  return (
    <>
      {loading && <KenLoader />}
      <Paper className={classes.paperCustomII}>
        {isMobile ? (
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel id="created-events-tab-mobile-label">Status</InputLabel>
            <Select
              labelId="created-events-tab-mobile-label"
              id="created-events-tab-mobile"
              value={tab || 'inreview'}
              label="Status"
              onChange={(e) => handleTabChange(e as any, e.target.value)}
            >
              <MenuItem value="inreview">In review</MenuItem>
              <MenuItem value="approved">Approved</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        ) : (
          <Tabs
            value={tab}
            onChange={handleTabChange}
            aria-label="My Bookings Tabs"
            indicatorColor="primary"
            textColor="primary"
            variant="standard"
            className={classes.tabHeader}
          >
            <Tab value={'inreview'} className={classes.tab} label="In review" />
            <Tab value={'approved'} className={classes.tab} label="Approved" />
            <Tab value={'rejected'} className={classes.tab} label="Rejected" />
          </Tabs>
        )}
        <Box component={'div'} className={`${classes.tabEvent} scrollbar-cusgray`}>
          <TabPanel value={tab} index={'inreview'}>
            {eventsData.inreview.map((items: RegisteredEventCards, index: number) => {
              return <RegisteredEventCardsList data={items} status={tab as any} />;
            })}
          </TabPanel>
          <TabPanel value={tab} index={'approved'}>
            {eventsData.approved.map((items: RegisteredEventCards, index: number) => {
              return <RegisteredEventCardsList data={items} status={tab as any} />;
            })}
          </TabPanel>
          <TabPanel value={tab} index={'rejected'}>
            {eventsData.rejected.map((items: RegisteredEventCards, index: number) => {
              return <RegisteredEventCardsList data={items} status={tab as any} handleOpen={handleOpen as () => {}} />;
            })}
          </TabPanel>
        </Box>
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box sx={style}>
            <EventFeedback eventId={eventId} onClose={handleClose} />
          </Box>
        </Modal>
      </Paper>
    </>
  );
};

export default RegisteredEvents;
